import { createFileRoute } from '@tanstack/react-router';
import DripEmailReportPage from '../views/drip/emails/email/report';

export const Route = createFileRoute('/drip/emails/$uuid/report')({
  component: DripEmailReportPage,
});
